import PropTypes from 'prop-types';
import useBreakpoint from './useBreakpoint';
/**
 * Component that conditionally renders some content depending on the current
 * screen size.
 *
 * @param {object} props - component's props
 * @param {string} props.breakpoint - name of the breakpoint to listen to
 * @param {string} props.children - content to be shown when breakpoint is satisfied
 *
 * @returns {boolean} whether the breakpoint condition is met or not.
 *
 * @example
 * <Responsive breakpoint={TABLET}>{someTabletContent}</Responsive>
 */

export default function Responsive(_ref) {
  var breakpoint = _ref.breakpoint,
      children = _ref.children;

  if (useBreakpoint({
    breakpoint: breakpoint
  })) {
    return children;
  }

  return null;
}
Responsive.propTypes = {
  breakpoint: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
};